// Composable for Admin Auth (server-side session via Keycloak)
import { adminAuth, type AdminUserInfo } from '~/services/admin-auth'

export function useAdminAuth() {
  const isAdminState = useState('admin-is-authenticated', () => false)
  const adminUserState = useState<AdminUserInfo | null>('admin-user-info', () => null)

  const isAdmin = computed(() => isAdminState.value)
  const adminUser = computed(() => adminUserState.value)

  async function refreshAdminState() {
    const session = await adminAuth.checkSession()
    isAdminState.value = session.authenticated
    adminUserState.value = session.user
  }

  async function validateLogin(code: string) {
    const result = await adminAuth.validateLogin(code)
    if (result.success && result.user) {
      isAdminState.value = true
      adminUserState.value = result.user
    }
    return result
  }

  async function clearTokens() {
    await adminAuth.logout()
    isAdminState.value = false
    adminUserState.value = null
  }

  function isAuthenticated(): boolean {
    return isAdminState.value
  }

  async function checkAdminSession(): Promise<boolean> {
    const session = await adminAuth.checkSession()
    isAdminState.value = session.authenticated
    adminUserState.value = session.user
    return session.authenticated
  }

  function getStoredUserInfo() {
    return adminUserState.value
  }

  function getUserGroups(): string[] {
    return adminUserState.value?.groups || []
  }

  return {
    isAdmin,
    adminUser,
    refreshAdminState,
    validateLogin,
    clearTokens,
    isAuthenticated,
    checkAdminSession,
    getStoredUserInfo,
    getUserGroups
  }
}

/** @deprecated Use useAdminAuth */
export function useAdminCognitoAuth() {
  return useAdminAuth()
}
